import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".scrollableexpandingcontent").forEach((el) => {
    const contents = el.querySelectorAll(".scroll-content");

    contents.forEach((content) => {
      const height = content.offsetHeight;
      const styles = window.getComputedStyle(content);
      const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
      const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

      content.setAttribute("data-height", height + margin + padding);
    });

    gsap.set(contents, { height: 0 });

    if (contents.length > 0) {
      gsap.set(contents[0], { height: contents[0].dataset.height });
      const firstSection = contents[0].closest(".scroll-section");
      const firstSectionImage = el.querySelector(`.section-image[data-pos="${firstSection.dataset.index}"]`);
      firstSection.classList.add("is-active");
      if (firstSectionImage) {
        gsap.set(firstSectionImage, { opacity: 1 });
      }
    }

    const timeline = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: el.querySelector(".scroll-sections"),
        start: "top 70%",
        end: "bottom-=10% 50%",
        scrub: true,
        markers: false,
      },
    });

    contents.forEach((content, index) => {
      const section = content.closest(".scroll-section");
      const sectionImage = el.querySelector(`.section-image[data-pos="${section.dataset.index}"]`);
      const prevSection = index > 0 ? contents[index - 1].closest(".scroll-section") : null;

      timeline.to(content, { height: content.dataset.height });

      if (prevSection) {
        const prevSectionImage = el.querySelector(`.section-image[data-pos="${prevSection.dataset.index}"]`);
        timeline.to(prevSection, { className: "scroll-section relative is-completed" }, "<");
        timeline.to(prevSectionImage, { opacity: 0, duration: 0.1 }, "<");
      }

      timeline.to(section, { className: "scroll-section relative is-active" }, "<");
      timeline.to(sectionImage, { opacity: 1, duration: 0.1 }, "<");
    });

    ScrollTrigger.refresh();
  });
});
